import gql from 'graphql-tag';

export default fields => gql`
query {
  listWebsites {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/AllQuery.js